import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=85bf1238"
import script from "./AppFooter.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppFooter.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports